import { getAnalytics, logEvent } from 'firebase/analytics';

let analyticsInstance = null;

export const getAnalyticsInstance = () => {
  if (!analyticsInstance) {
    try {
      analyticsInstance = getAnalytics();
    } catch (error) {
      console.warn('Failed to initialize Firebase Analytics:', error);
      analyticsInstance = null;
    }
  }
  return analyticsInstance;
};

export { logEvent };
